var _rect, _circle, _circle2, _path, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "url(#paint0_linear_1605_4104)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 34.5,
    stroke: "white",
    strokeWidth: 7,
    strokeMiterlimit: 2.16568,
    strokeDasharray: "15 10"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 25.5,
    fill: "black",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9023 44H27.9199V42.1104L31.1455 38.8496C31.7959 38.1816 32.3174 37.625 32.71 37.1797C33.1084 36.7285 33.3955 36.3184 33.5713 35.9492C33.7529 35.5801 33.8438 35.1846 33.8438 34.7627C33.8438 34.2529 33.7002 33.8721 33.4131 33.6201C33.1318 33.3623 32.7539 33.2334 32.2793 33.2334C31.7812 33.2334 31.2979 33.3477 30.8291 33.5762C30.3604 33.8047 29.8711 34.1299 29.3613 34.5518L27.8848 32.8027C28.2539 32.4863 28.6436 32.1875 29.0537 31.9062C29.4697 31.625 29.9502 31.3994 30.4951 31.2295C31.0459 31.0537 31.7051 30.9658 32.4727 30.9658C33.3164 30.9658 34.04 31.1182 34.6436 31.4229C35.2529 31.7275 35.7217 32.1436 36.0498 32.6709C36.3779 33.1924 36.542 33.7842 36.542 34.4463C36.542 35.1553 36.4014 35.8027 36.1201 36.3887C35.8389 36.9746 35.4287 37.5547 34.8896 38.1289C34.3564 38.7031 33.7119 39.3389 32.9561 40.0361L31.3037 41.5918V41.7148H36.9023V44ZM42.8965 35.791C43.6816 35.791 44.3789 35.9404 44.9883 36.2393C45.6035 36.5381 46.0869 36.9775 46.4385 37.5576C46.79 38.1377 46.9658 38.8525 46.9658 39.7021C46.9658 40.6279 46.7725 41.4277 46.3857 42.1016C46.0049 42.7695 45.4336 43.2822 44.6719 43.6396C43.916 43.9971 42.9727 44.1758 41.8418 44.1758C41.168 44.1758 40.5322 44.1172 39.9346 44C39.3428 43.8887 38.8242 43.7158 38.3789 43.4814V41.1348C38.8242 41.3691 39.3574 41.5684 39.9785 41.7324C40.6055 41.8906 41.1943 41.9697 41.7451 41.9697C42.2842 41.9697 42.7383 41.8994 43.1074 41.7588C43.4766 41.6123 43.7549 41.3896 43.9424 41.0908C44.1357 40.7861 44.2324 40.3994 44.2324 39.9307C44.2324 39.3037 44.0215 38.8232 43.5996 38.4893C43.1777 38.1553 42.5303 37.9883 41.6572 37.9883C41.3232 37.9883 40.9746 38.0205 40.6113 38.085C40.2539 38.1494 39.9551 38.2139 39.7148 38.2783L38.6338 37.6982L39.1172 31.1504H46.0869V33.4531H41.499L41.2617 35.9756C41.4609 35.9346 41.6777 35.8936 41.9121 35.8525C42.1465 35.8115 42.4746 35.791 42.8965 35.791Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 20,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_4104",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#21B152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D585"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip25);
export default __webpack_public_path__ + "static/media/chip25.7ff87f6d740410c85605a5c94d74624b.svg";
export { ForwardRef as ReactComponent };